export const GET_ALL_SPORTS = "GET_ALL_SPORTS"
export const GET_ALL_SPORTS_RESPONSE_SUCCESS = "GET_ALL_SPORTS_RESPONSE_SUCCESS"
export const CREATE_SPORT = "CREATE_SPORT"
export const UPDATE_SPORT = "UPDATE_SPORT"
export const DELETE_SPORT = "DELETE_SPORT"
export const ASSIGN_MARKET_NAME = "ASSIGN_MARKET_NAME"
